import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CreateLead } from '../../Models/createLead';
import { leadUpdate, UpdateLead } from '../../Models/updateLead';
import { UpdateResponse } from '../../Models/updateResponse';
import { YaTenemosEstado } from '../../Models/ya-tenemos-datos-estado.enum';
import { getFromStorage, getSessionId, saveToStorage } from '../../helpers/storageUtils';
import { FEEDBACK } from '../../routes.constans';
import { TokenService } from '../../shared/services/token.service';
import { UtmHandlerService } from '../../shared/services/utm-handler.service';
import { UtilsService } from './../utils.service';

@Injectable({
  providedIn: 'root',
})
export class LeadsService {
  baseUri = environment.URL_CREAR_LEAD;
  urlActualizarLead = environment.URL_ACTUALIZAR_LEAD;
  _body = {};
  codAsesor = '';
  tokenService = inject(TokenService);
  utmHandlerService = inject(UtmHandlerService);
  SESSION_ID = getSessionId().toString();
  GENERAL_CLIENT_ID = environment.GENERAL_CLIENT_ID;

  constructor(
    private http: HttpClient,
    private router: Router,
    private utils: UtilsService,
  ) {}

  private createBody(dataLead: CreateLead | UpdateLead): CreateLead | UpdateLead {
    return {
      ...dataLead,
      set_utm_campaign: this.utmHandlerService.getUtmParams()['utm_campaign'] || '',
      set_utm_content: this.utmHandlerService.getUtmParams()['utm_content'] || '',
      set_utm_medium: this.utmHandlerService.getUtmParams()['utm_medium'] || '',
      set_utm_source: this.utmHandlerService.getUtmParams()['utm_source'] || '',
    };
  }

  public postCrearLeads(dataLead: CreateLead, sessionId: string): Observable<any> {
    const finalBody = this.createBody(dataLead);

    const headers = this.utils.getHeaders(this.SESSION_ID);
    return this.http
      .post<any>(this.baseUri, finalBody, {
        headers: headers,
      })
      .pipe(
        tap((resp) => {
          console.log('postCrearLeads response:', resp);
          try {
            saveToStorage('LeadResponse', resp, 'session');
          } catch (e) {
            console.error('Error saving LeadResponse to sessionStorage:', e);
          }
        }),
        catchError((err) => {
          console.error('Error en postCrearLeads:', err);
          return throwError(() => err);
        }),
      );
  }

  public actualizarLead(
    dataLead: UpdateLead,
    sessionId: string,
    leadId: string,
  ): Observable<UpdateResponse> {
    const finalBody = this.createBody(dataLead);
    const headers = this.utils.getHeaders(this.SESSION_ID);
    return this.http.put<UpdateResponse>(
      this.urlActualizarLead.concat('/').concat(leadId),
      finalBody,
      { headers: headers },
    );
  }

  public actualizarLeads(
    dataLead: leadUpdate,
    sessionId: string,
    leadId: string,
  ): Observable<UpdateResponse> {
    const finalBody = this.createBody(dataLead);
    const headers = this.utils.getHeaders(this.SESSION_ID);
    const url = `${this.urlActualizarLead}/${leadId}`;

    return this.http.put<UpdateResponse>(url, finalBody, { headers });
  }

  public handleSuccess(resp: UpdateResponse): void {
    if (resp) {
      if (this.codAsesor === undefined || this.codAsesor === '') {
        saveToStorage('cotizacion_pausa_estado', YaTenemosEstado.LEAD_ABANDONO_RESUMEN, 'session');
        this.router.navigate([FEEDBACK]);
      } else {
        this.router.navigate([FEEDBACK], {
          queryParams: { codigoAsesor: this.codAsesor },
        });
      }
    }
  }

  public UpdateInfoLead(updateData: any, leadIdParam?: string) {
    let leadId = leadIdParam || '';

    if (!leadId) {
      const leadData = getFromStorage<any>('LeadResponse', 'session');
      leadId = leadData?.data?.Id || leadData?.lead_id || '';
    }

    if (!leadId) {
      console.error('❌ UpdateInfoLead: No se encontró leadId');
    }

    const headers = this.utils.getHeaders(this.SESSION_ID);
    const url = `${this.urlActualizarLead}/${leadId}`;
    return this.http.put<any>(url, updateData, { headers });
  }
}
